module.exports = __webpack_public_path__ + "static/media/ic-dura-o.dbf7f70a.svg";